module.exports = __webpack_public_path__ + "media/img/list-0e985fa31b047edc8bbd224544c938c4.svg";